"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var HelpIcon = function HelpIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#333F48' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 10C1 5.032 5.032 1 10 1C14.968 1 19 5.032 19 10C19 14.968 14.968 19 10 19C5.032 19 1 14.968 1 10ZM17.2002 9.99995C17.2002 6.03005 13.9701 2.79995 10.0002 2.79995C6.03031 2.79995 2.80021 6.03005 2.80021 9.99995C2.80021 13.9698 6.03031 17.1999 10.0002 17.1999C13.9701 17.1999 17.2002 13.9698 17.2002 9.99995ZM9.9999 14.4999C9.5049 14.4999 9.0999 14.0949 9.0999 13.5999V9.9999C9.0999 9.5049 9.5049 9.0999 9.9999 9.0999C10.4949 9.0999 10.8999 9.5049 10.8999 9.9999V13.5999C10.8999 14.0949 10.4949 14.4999 9.9999 14.4999ZM10.8999 7.3H9.0999V5.5H10.8999V7.3Z",
    fill: color
  }));
};
var _default = HelpIcon;
exports.default = _default;